// Lucide icon: list-checks (https://lucide.dev/icons/list-checks)
import { ListChecks } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconAuditLog = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <ListChecks />
    </IconComponentStyled>
  )
}
